module.exports = __webpack_public_path__ + "img/menu_img.10d17f86.png";